import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as ai from "../../services/aiAssistantService";
import { languageLabel } from "./aiHelpers";

const WHEN = { earliest: "As soon as possible", morning: "Morning", afternoon: "Afternoon", evening: "Evening" };

// Callbacks the assistant promised customers when your team was closed. Oldest first, so the longest wait is
// at the top when you open for the day.
const CallbacksTab = () => {
  const [status, setStatus] = useState("open");
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setRows(await ai.getCallbacks(status));
      setError(null);
    } catch (e) {
      setError((e && e.message) || "Could not load callbacks");
    }
  }, [status]);

  useEffect(() => {
    setRows(null);
    load();
  }, [load]);

  const mark = async (id, next) => {
    const res = await ai.setCallbackStatus(id, next);
    if (res && res.success) load();
    else toast.error((res && res.message) || "Could not update the callback");
  };

  if (error) return <div className="alert alert-danger">{error}</div>;

  return (
    <>
      <div className="d-flex align-items-center gap-2 mb-3">
        <label className="small text-muted mb-0" htmlFor="cb-status">
          Show
        </label>
        <select id="cb-status" className="form-select form-select-sm" style={{ width: 160 }} value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="open">Waiting</option>
          <option value="done">Done</option>
          <option value="missed">Missed</option>
          <option value="all">All</option>
        </select>
      </div>
      {!rows ? (
        <div className="text-muted py-4">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="text-center text-muted py-5 small">No callbacks here.</div>
      ) : (
        <div className="list-group shadow-sm rounded-4">
          {rows.map((c) => (
            <div className="list-group-item" key={c.id}>
              <div className="d-flex flex-wrap align-items-center gap-2">
                <div className="me-auto">
                  <span className="fw-semibold">{c.customer || c.phone}</span>
                  {c.customer && <span className="text-muted small ms-2">{c.phone}</span>}
                  <span className="badge text-bg-light border ms-2">{WHEN[c.preferred] || c.preferred}</span>
                  {languageLabel(c.language) && <span className="badge text-bg-light border ms-1">{languageLabel(c.language)}</span>}
                </div>
                <span className="text-muted small">{c.created_at}</span>
                {c.status === "open" && (
                  <>
                    <button type="button" className="btn btn-sm btn-outline-success" onClick={() => mark(c.id, "done")}>
                      Done
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => mark(c.id, "missed")}>
                      Missed
                    </button>
                  </>
                )}
                {c.status !== "open" && <span className={`badge ${c.status === "done" ? "text-bg-success" : "text-bg-secondary"}`}>{c.status}</span>}
              </div>
              <div className="small mt-1">
                <strong>{c.reason}</strong>
              </div>
              <div className="text-muted small">{c.summary}</div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default CallbacksTab;
